.choices {
  display: flex;
  gap: 16px;
  padding: 8px 0;
}

.choiceCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  padding: 20px;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    border-color: var(--dark-40);
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}

.choiceCardDashed {
  border-style: dashed;
}

.choiceIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--dark-3);
}

.choiceText {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.formLayout {
  display: flex;
  gap: 24px;
  padding: 8px 0;
}

.uploadColumn {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 280px;
  flex-shrink: 0;
}

.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  aspect-ratio: 4 / 5;
  border: 1px dashed var(--dark-8);
  border-radius: 10px;
  background: var(--dark-2);
  cursor: pointer;
  overflow: hidden;
  padding: 16px;
  text-align: center;

  &:hover {
    border-color: var(--dark-40);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }
}

.uploading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.dropzoneIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: var(--default-bg);
  border: 1px solid var(--dark-8);
}

.rejectedCallout {
  border-radius: 8px;
  background: #fdecec;
  padding: 10px 12px;
}

.fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.appearance {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.selectRow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.toggleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  padding: 14px 16px;
  background: var(--dark-2);
}

.toggleText {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toggleSwitch {
  cursor: pointer;
}

.voiceSection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.voicePresetRow {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 360px;
}

.voicePresetSelect {
  flex: 1;
  min-width: 0;
}

.voiceRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voiceDropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px;
  border: 1px dashed var(--dark-8);
  border-radius: 10px;
  background: var(--dark-2);
  cursor: pointer;
  text-align: center;

  &:hover {
    border-color: var(--dark-40);
  }
}

.voiceUploading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
}

.voiceReplace {
  cursor: pointer;
  text-decoration: underline;
}

.catalogGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 8px 0;
  max-height: min(560px, 60vh);
  overflow-y: auto;
}

.catalogCard {
  position: relative;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  overflow: hidden;
}

.catalogPoster {
  position: relative;
}

.catalogPhoto {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
}

.catalogPlayButton {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--dark-90);
  color: var(--white);
  cursor: pointer;

  &:hover {
    background: var(--dark-100);
  }

  &:focus-visible {
    outline: 2px solid var(--white);
    outline-offset: 2px;
  }
}

.catalogInfo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
}

.catalogPersona {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.catalogSelectButton {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: none;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--dark-90);
    outline-offset: 2px;
  }
}

.lockedPhoto {
  aspect-ratio: 4 / 5;
  border-radius: 10px;
  overflow: hidden;
  background: var(--dark-2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
